/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Level_2Inputs */

const en_sch_level_2 = /** @type {(inputs: Sch_Level_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic`)
};

const de_sch_level_2 = /** @type {(inputs: Sch_Level_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic`)
};

/**
* | output |
* | --- |
* | "Epic" |
*
* @param {Sch_Level_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_level_2 = /** @type {((inputs?: Sch_Level_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Level_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_level_2(inputs)
	return en_sch_level_2(inputs)
});